module.exports = __webpack_public_path__ + "demoImage.jpg";